export default __webpack_public_path__ + "static/media/bird1.7df543ea.svg";